var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSso(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "sso_svg__a",
    d: "M0 .983h63.906v41.274H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sso_svg__c",
    d: "M0 .982h48.036v41.227H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sso_svg__e",
    d: "M1.131.458h32.953v25.84H1.131z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sso_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sso_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.906 28.164a14.085 14.085 0 00-8.765-13.07C51.071 5.06 44.498.983 36.446.983 28.88.983 22.32 5.33 19.103 11.69a7.923 7.923 0 00-3.126-.642c-4.308 0-7.81 3.44-7.973 7.745A12.066 12.066 0 000 30.177c0 6.671 5.365 12.081 11.982 12.081h39.943s11.982-2.241 11.982-14.094",
    fill: "#3CC",
    fillRule: "nonzero",
    mask: "url(#sso_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sso_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sso_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.446.982c-7.568 0-14.128 4.348-17.344 10.708-5.116-2.195-10.883 1.453-11.097 7.103A12.068 12.068 0 000 30.178c0 6.335 4.84 11.523 10.995 12.03l37.04-37.346c-3.326-2.675-7.24-3.88-11.589-3.88",
    fill: "#42E0D0",
    fillRule: "nonzero",
    mask: "url(#sso_svg__d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.346 33.891)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sso_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sso_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.131 22.605c0 2.041 1.64 3.693 3.663 3.693h25.628c2.021 0 3.662-1.653 3.662-3.693V4.15c0-2.038-1.642-3.691-3.662-3.691H4.794c-2.023 0-3.663 1.653-3.663 3.691v18.456z",
    fill: "#FFCE4D",
    fillRule: "nonzero",
    mask: "url(#sso_svg__f)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.459 42.994a3.096 3.096 0 00-3.085-3.108c-1.702 0-3.081 1.392-3.081 3.108 0 1.195.675 2.22 1.657 2.74l-1.657 8.917h6.166l-1.66-8.916a3.103 3.103 0 001.66-2.741",
    fill: "#5E6174",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.852 34.348H38.36v-6.46c0-3.563-2.874-6.461-6.408-6.461-3.532 0-6.406 2.898-6.406 6.46v6.46h-5.492v-6.46c0-6.615 5.337-11.997 11.898-11.997 6.563 0 11.9 5.382 11.9 11.997v6.46z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}

export default "data:image/svg+xml;base64,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";
export { SvgSso as ReactComponent };